<template>
  <div class="headline">
    <div class="secretlab_menuline slmm-above default">
      <div class="header-widget widget_custom_post_widget">
        
        <!-- <section class="kc-elm kc-css-4636935 kc_row">
          <div class="befbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
          <div class="befbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
          <div class="aftbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
          <div class="aftbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
          <div class="befbgr5" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
          <div class="befbgr6" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
          <div class="aftbgr7" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
          <div class="aftbgr8" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
          <div class="kc-row-container kc-container">
            <div class="kc-wrap-columns">
              <div class="kc-elm kc-css-460397 kc_col-sm-6 kc_column kc_col-sm-6">
                <div class="kc-col-container">
                  <div class="kc-elm kc-css-3790811 kc_row kc_row_inner sst-flex-row-inner">
                    <div class="kc-elm kc-css-5816641 kc_col-sm-4 kc_column_inner kc_col-sm-4">
                      <div class="kc_wrapper kc-col-inner-container">
                        <div class="ssc_icon_box kc-elm kc-css-6074564 template1">
                          <div class="icon_box">
                            <div class="bgr_no" style="width:8px; height:8px;">
                              <div></div>
                            </div>
                            <div
                              class="c_img"
                              style="margin-top: -8px; line-height:8px; height:8px; width:8px;"
                            >
                              <img
                                src="../../assets/images/Marker.png"
                                :alt="getSiteInfo.phone"
                                style="max-width: 8px; max-height: 8px;margin-top: calc((8px - 8px)/2);"
                              />
                            </div>
                          </div>
                          <div class="cont_box">
                            <div class="title">
                              <localized-link to="/" :title="getSiteInfo.phone">{{getSiteInfo.phone}}</localized-link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="kc-elm kc-css-6256094 kc_col-sm-8 kc_column_inner kc_col-sm-8">
                      <div class="kc_wrapper kc-col-inner-container">
                        <div class="ssc_icon_box kc-elm kc-css-3806421 template1">
                          <div class="icon_box">
                            <div class="bgr_no" style="width:8px; height:8px;">
                              <div></div>
                            </div>
                            <div
                              class="c_img"
                              style="margin-top: -8px; line-height:8px; height:8px; width:8px;"
                            >
                              <img
                                src="../../assets/images/Marker.png"
                                alt="info@example.com"
                                style="max-width: 8px; max-height: 8px;margin-top: calc((8px - 8px)/2);"
                              />
                            </div>
                          </div>
                          <div class="cont_box">
                            <div class="title">
                              <localized-link to="/" :title="getSiteInfo.email">{{getSiteInfo.email}}</localized-link>
                            </div>
                            <div class="description lines0">
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="kc-elm kc-css-4438202 kc_col-sm-3 kc_column kc_col-sm-3">
                <div class="kc-col-container">
                  <div class="ssc_icon_box kc-elm kc-css-7088263 template1">
                    <div class="icon_box">
                      <div class="bgr_no" style="width:8px; height:8px;">
                        <div></div>
                      </div>
                      <div
                        class="c_img"
                        style="margin-top: -8px; line-height:8px; height:8px; width:8px;"
                      >
                        <img
                          src="../../assets/images/Marker.png"
                          alt="Follow Us:"
                          style="max-width: 8px; max-height: 8px;margin-top: calc((8px - 8px)/2);"
                        />
                      </div>
                    </div>
                    <div class="cont_box">
                      <div class="title">{{ $t('follow_us') }}:</div>
                      <div class="description lines0">
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="kc-elm kc-css-9871284 kc_col-of-5 kc_column kc_col-of-5">
                <div class="kc-col-container">
                  <div class="kc-elm kc-css-1280198 kc-multi-icons-wrapper">
                    <a
                      v-for="(network, index) in getSocialNetworks"
                      :key="index"
                      :href="network.url"
                      target="_blank"
                      title
                      :class="'multi-icons-link multi-icons' + network.icon"
                    >
                      <span></span>
                      <i :class="network.icon"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> -->
        <section
          id="stickymenu"
          class="kc-elm kc-css-8638657 kc_row"
          v-bind:class="{ 'fixed animated slideInDown': fixed }"
        >
          <div class="befbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
          <div class="befbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
          <div class="aftbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
          <div class="aftbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
          <div class="befbgr5" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
          <div class="befbgr6" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
          <div class="aftbgr7" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
          <div class="aftbgr8" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
          <div class="kc-row-container kc-container header-menu">
            <div class="kc-wrap-columns">
              <div class="kc-elm kc_col-sm-3 kc_column kc_col-sm-3">
                <div class="col_logo kc-col-container">
                  <div class="type1 mo none kc-elm kc-css-7213673 ssc_img_ef">
                    <div class="iw">
                      <localized-link to="/" title target="_self" class="openlink open_custom_link">
                        <img class="globaldev-logo-img" src="../../assets/images/LogoBase-blanco-naranja-transp.png" alt />
                        <h1 class="white globaldev-logo">Global<span class="orange">Dev</span></h1>
                      </localized-link>
                    </div>
                  </div>
                </div>
              </div>
              <div class="kc-elm kc_col-sm-7 kc_column kc_col-sm-7 menuglobaldev">
                <div class="kc-col-container">
                  <div class="ssc_menu kc-elm kc-css-297664">
                    <div class="slmm-respmenu">
                      <button
                        type="button"
                        class="slm-open-menu-list"
                        data-slmenu-target="#slmenu-949907"
                        v-on:click="myFilter()"
                      >
                        <i class="slmm-icon-menu-hiden fa-bars"></i>
                        <i class="slmm-icon-menu-shown nat-620" style="display: none;"></i>
                      </button>
                    </div>
                    <div id="slmenu-949907"  v-bind:class="{ 'slmm-mobile-hide': !isActive }">
                      <ul id="menu-demomenu" class="slmm">
                        <li
                          v-for="item in menu"
                          :key="item.name"
                          class="slm-dropd-item main-menu-item slm-mega-item menu-item-even slm-menu-item-depth-0 menu-item menu-item-type-post_type menu-item-object-page both"
                          style="z-index: 1; "
                        >
                          <localized-link :to="item.router_link" class="menu-link main-menu-link">
                            <span v-on:click="myFilter()">{{ $t(item.name) }}</span>
                          </localized-link>
                        </li>
                        <li
                          id="nav-menu-item-4614"
                          class="slmm-mobile-hide slm-dropd-item main-menu-item slm-mega-item menu-item-even slm-menu-item-depth-0 menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children both"
                          style="z-index: 1; "
                        >
                          <localized-link  to="#" class="menu-link main-menu-link">
                            <span>
                              <flag :iso="$i18n.locale" />
                              {{ $i18n.locale.toUpperCase() }}
                            </span>
                            <i class="caret fa-chevron-down"></i>
                          </localized-link>
                          <ul
                            class="slm-sub-menu menu-odd slm-menu-depth-1 slm-submenu-pos-right"
                            style
                          >
                            <language-switcher v-slot="{ links }" >
                              <router-link v-for="link in links" :key="link.langIndex" :to="link.url" >
                                <img :src="getCountryFlagURL(link.langIndex)" alt="" />
                                <flag :iso="link.langIndex" />
                                <span class="menu-link sub-menu-link">{{ link.langIndex }}</span>
                              </router-link>
                            </language-switcher>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="kc-elm kc_col-sm-2 kc_column kc_col-sm-2 slmm-mobile-hide">
                <div class="kc-col-container">
                  <div class="ssc_btn kc-elm kc-css-3756033">
                    <localized-link
                      class="ssc_button none"
                      to="/hire-us"
                      target="_self"
                    >
                      <span>{{ $t("menu.get_quote")}}</span>
                    </localized-link>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";

export default {
  name: "Header",
  data() {
    return {
      msg: "Header",
      fixed: false,
      isActive: false,
      langs: ["us", "es"],
      menu: [
        {
          "name": "menu.home",
          "router_link": "/"
        },
        {
          "name": "menu.dedicated_teams",
          "router_link": "/dedicated-teams"
        },
        {
          "name": "menu.industries",
          "router_link": "/industries"
        },
        {
          "name": "menu.careers",
          "router_link": "/careers"
        },
        {
          "name": "menu.about_us",
          "router_link": "/about-us"
        }
      ]
    };
  },
  computed: {
    ...Vuex.mapState(["site_info"]),
    ...Vuex.mapGetters(["getSiteInfo", "getSocialNetworks"])
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    myFilter(){
      this.isActive = !this.isActive;
    },
    handleScroll(event) {
      if (window.scrollY === 0 && this.fixed === true) {
        this.fixed = false;
      } else if (window.scrollY !== 0 && this.fixed !== true) {
        this.fixed = true;
      }
    },
    getCountryFlagURL(locale) {
      // Map locales to country codes to use with Country Flags API
      const map = {
        en: "us",
        cs: "cz",
      };
      return `https://www.countryflags.io/${map[locale]}/shiny/24.png`;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sub-menu-link{
  font-size: 22px;
  line-height: 1;
  color: #666666;
  font-family: Catamaran;
  font-weight: 400;
  background: rgba(255, 255, 255, 0);
  border-bottom: 2px solid #f8f8f8;
  padding-right: 3px;
  padding-left: 8px;
  text-transform: uppercase;
}
.globaldev-logo-img{
  width: 49px;
  float: left;
  position: absolute;
  left: -32px;
  top: 13px;
}
.globaldev-logo{
  font-size:35px;
  line-height: 1;
}
.open_custom_link{
  text-decoration: none;
}
.white{
  color: #FFFFFF;
}
.orange{
  color: #ED7D31;
}
.header-menu{
  max-width: calc(50% + 300px);
}
span.flag-icon.flag-icon-squared.flag-icon {
  top: -4px;
}

@media all and (min-width:320px) and (max-width:767px){
  .globaldev-logo{
     font-size:20px;
  }
}
@media all and (min-width:768px) and (max-width:1000px){
.globaldev-logo{
     font-size:21px;
  }
  .kc-css-system .kc-css-297664 .slmm li a, .kc-css-system .kc-css-297664 .slmm li>span{
    font-size:14px;
    padding: 20px 0px 20px 10px;
  }
}
@media all and (min-width:1000px) and (max-width:1300px){
  .kc-css-system .kc-css-3756033 .ssc_button{
    font-size:14px;
    padding: 9px 21px 9px 22px;
    top:5px;
  }
.globaldev-logo{
     font-size:24px;
     margin-top: 29px;
  }
  .kc-css-system .kc-css-297664 .slmm li a, .kc-css-system .kc-css-297664 .slmm li>span{
    font-size:14px;
    padding: 20px 0px 20px 9px;
  }
}
@media all and (min-width:1300px) and (max-width:1500px){
.globaldev-logo{
     font-size:30px;
  }
  .kc-css-system .kc-css-297664 .slmm li a, .kc-css-system .kc-css-297664 .slmm li>span{
    font-size:16px;
    padding: 20px 16px 20px 3px;
  }
}

@media all and (min-width:1500px) and (max-width:1800px){
  .globaldev-logo{
    font-size:30px;
  }

  .kc-css-system .kc-css-297664 .slmm li a, .kc-css-system .kc-css-297664 .slmm li>span{
    font-size:15px;
    padding: 20px 16px 20px 10px;
  }
  
}
/* @media all and (min-width:1200px) and (max-width:1400px){
.globaldev-logo{
     font-size:10px;
  }
} */


@media screen and (max-width:767px) {
  .menuglobaldev{
    width: 100% !important;
    position: absolute;
  }

	body.kc-css-system .kc_column,
	body.kc-css-system .kc_column_inner {
		width: 50%;
  }
  .slmm-mobile-hide {
      display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue